module.exports = {"moneda":{"1":"PEN","2":"USD"},"tipoCuenta":{"CCT":"C","CAH":"H"},"bancos":{"0002":"01","0003":"02","0007":"03","0011":"04","0012":"05","0018":"06","0023":"07","0035":"08","0038":"09","0049":"10","0053":"11","0101":"13","0004":"14","0117":"15","0127":"16","0120":"17","0109":"18"},"tipoDocumento":{"DNI":"D","CEX":"E","RUC":"R","PAS":"PAS"}}


//////////////////
// WEBPACK FOOTER
// ./jsons/virtual-data-transformation.yml
// module id = ./jsons/virtual-data-transformation.yml
// module chunks = 34